//neet to refact....

$('.item-content').hide();
$('.item-link').click(function(){
    $(this).parent('.item-container').children('.item-content').slideToggle( "slow" );
    $(this).children('.item-box').children('.icon').toggleClass('close');
});

$('.sub-item-content').hide();
$('.sub-item-link').click(function(){
    $(this).parent('.sub-item-container').children('.sub-item-content').slideToggle( 200 );
    $(this).children('.sub-item-box').children('.bullet').toggleClass('close');
});


$(function(){
    var content = $('.item-real-content').find('img');
    $.each(content, function(i, element){
        var src = $(element).attr('src');
        $(element).wrap( '<a href="'+src+'" data-lightbox="image-1"></a>' );

    });
    var content = $('.sub-item-content').find('img');
    $.each(content, function(i, element){
        var src = $(element).attr('src');
        $(element).wrap( '<a href="'+src+'" data-lightbox="image-1"></a>' );

    });

});